import Q from 'q';

// 平台订单管理
import web_common_tourCutOrder_orderList from '@/lib/data-service/default/web_common_tourCutOrder_orderList';

import Citys from '@/component/citys/index.vue';

export default {
  components: {
    Citys
  },
  data() {
    return {
      form: {
        currentPage: 1,
        pageSize: 10,
        productNo: '',
        productName: '',
        buyerName: '',
        cutOrderNo: '',
        teamStart: '',
        teamEnd: '',
        orderDateStart: '',
        orderDateEnd: '',
        tripDay: '',
        productType: '',
        productAreasType: '',
        orderState: '',
        fromCity: '',
        toCity: '',
      },
      allocation: {
        tripDay: [
          { label: '全部', value: '' },
          { label: '一天', value: 1 },
          { label: '两天', value: 2 },
          { label: '三天', value: 3 },
          { label: '四天', value: 4 },
          { label: '五天', value: 5 },
          { label: '六天', value: 6 },
          { label: '七天', value: 7 },
          { label: '八天及八天以上', value: 8 }
        ],
        productType: [
          { label: '全部', value: '' },
          { label: '跟团游', value: 1 },
          { label: '自由行', value: 2 },
          { label: '当地游', value: 3 }
        ],
        productAreasType: [
          { label: '全部', value: '' },
          { label: '国内', value: 1 },
          { label: '出境', value: 2 }
        ],
        state: [
          { label: '全部', value: '' },
          { label: '待供应商确认', value: 1 },
          { label: '待平台确认', value: 2 },
          { label: '已确认', value: 3 },
          { label: '已结束', value: 4 },
          { label: '已取消', value: 5 },
          { label: '冻结', value: 6 },
          { label: '待结算定金', value: 7 },
          { label: '已结算定金', value: 8 },
        ]
      },
      state: '',
      loading: false,
      pager: {
        pageSizes: [10, 20, 30, 40, 50],
        totalCount: 0
      },
      orderList: [],
      show: false,
      dialogVisible: false,
      failReason: '',
    };
  },
  methods: {
    req_order_list(params, type) {
      this.loading = true;
      const _this = this;
      Q.when()
        .then(function() {
          return web_common_tourCutOrder_orderList(params);
        })
        .then(function(res) {
          const orderList = res.pageResult.pageData;
          orderList.forEach(function(item) {
            item.teamTimes = JSON.parse(item.teamTimes);
          });
          _this.orderList = orderList;
          _this.pager.totalCount = res.pageResult.totalCount;
          if (type) document.documentElement.scrollTop = 0;
          _this.loading = false;
        });
    },
    getFromCity (value) {
      this.form.fromCity = value;
    },
    getToCity (value) {
      this.form.toCity = value;
    },
    fold_change() {
      this.show = !this.show;
    },
    search() {
      this.req_order_list(this.form);
    },
    reset() {
      const pageSize = this.form.pageSize;
      const orderState = this.form.orderState;
      this.form = {
        currentPage: 1,
        pageSize,
        cutOrderNo: '',
        productName: '',
        buyerName: '',
        orderNo: '',
        teamStart: '',
        teamEnd: '',
        orderDateStart: '',
        orderDateEnd: '',
        tripDay: '',
        productType: '',
        productAreasType: '',
        orderState,
        fromCity: '',
        toCity: '',
      };
      this.$refs.fromCity.reset();
      this.$refs.toCity.reset();
      this.req_order_list(this.form);
    },
    to_detail(cutOrderNo) {
      this.$router.push({
        name: 'admin-cut-order-detail',
        query: { cutOrderNo }
      });
    },
    look_affirmBill(url) {
      if (url) {
        window.open(url.split('?')[0], '_blank');
      } else {
        this.$message.error('返回url为空，请联系管理员');
      }
    },
    look_failReason (failReason) {
      this.failReason = failReason;
      this.dialogVisible = true;
    },
    handleClose () {
      this.failReason = '';
      this.dialogVisible = false;
    },
    handleSizeChange(pageSize) {
      this.form.pageSize = pageSize;
      this.req_order_list(this.form, 'pageSize');
    },
    handleCurrentChange(currentPage) {
      this.form.currentPage = currentPage;
      this.req_order_list(this.form, 'currentPage');
    }
  },
  created() {},
  mounted() {},
  activated() {
    this.req_order_list(this.form);
  },
  deactivated() {},
  destroyed() {},
  watch: {
    state: function (newVal) {
      this.form.currentPage = 1;
      this.form.orderState = newVal;
      this.req_order_list(this.form);
    }
  },
  computed: {}
};
